import request from './request'

export default {
  list(data) {
    return request.post('/paymentMethod/list', data)
  },
  info(data) {
    return request.post('/paymentMethod/info', data)
  },
  save(data) {
    return request.post('/paymentMethod/save', data)
  },
  enable(data) {
    return request.post('/paymentMethod/enable', data)
  },
  disable(data) {
    return request.post('/paymentMethod/disable', data)
  },
  delete(data) {
    return request.post('/paymentMethod/delete', data)
  },
}
